module.exports = __webpack_public_path__ + "static/hero-image-36e6dca64449ca4a556f3487cbfa87ed.svg";